import { render, staticRenderFns } from "./CurrentEvent.vue?vue&type=template&id=0ad34979&scoped=true&"
import script from "./CurrentEvent.vue?vue&type=script&lang=js&"
export * from "./CurrentEvent.vue?vue&type=script&lang=js&"
import style0 from "./CurrentEvent.vue?vue&type=style&index=0&id=0ad34979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad34979",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VListItemTitle,VRow})
